import * as React from 'react';
export const puzzleSvg = React.forwardRef(function puzzleSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#50FAAB',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'm13.6 6.4-4.8 4.8h4.8V16l-4.8 4.8h4.8v4.8l4.8-4.8h-4.8V16l4.8-4.8h-4.8V6.4Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#211F35',
      fillRule: 'evenodd',
      d: 'M18.4 20.8a7.2 7.2 0 0 0 5.091-2.109 7.2 7.2 0 0 0 1.56-2.336 7.2 7.2 0 0 0-3.896-9.407A7.2 7.2 0 0 0 18.4 6.4h-4.8v4.8H8.8V16h4.8v4.8H8.8v4.8h4.8v-4.8h4.8Zm0-4.8v-4.8h-4.8V16h4.8Z',
      clipRule: 'evenodd',
    }),
  );
});
puzzleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var puzzle = {
  category: 'brand',
  colorable: false,
  name: 'puzzle',
  svg: puzzleSvg,
};
